import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, Inject, signal } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators,
  ReactiveFormsModule
} from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatMenuModule } from '@angular/material/menu';
import { MatDialogModule } from '@angular/material/dialog';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialog
} from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatIcon } from '@angular/material/icon';
import { ProfileType } from '../../../models/profiletype.model';
import { DialogService } from '../../../services/dialogservice';
import { MarketService } from '../../../services/marketservice';
import { NotificationService } from '../../../services/notificationservice';
import { Regions } from '../../../interfaces/regions';
import { FeedstockService } from '../../../services/feedstockservice';
import { LookUpService } from '../../../services/lookupservice';
import { HaulerService } from '../../../services/haulerservice';
import { SiteService } from '../../../services/siteservice';
import { States } from '../../../interfaces/states';
import { Cities } from '../../../interfaces/cities';
import { AppDialogComponent } from '../../common/app-dilaog/app-dialog.component';
import { IdName } from '../../../interfaces/pricematrixmodel';
import { GetDisposalMethodsResponse } from '../../../interfaces/feedstockstatus';
import { numericInputLimit } from '../../shared/commonutils/helper';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { RoleService } from '../../../services/role.service';
import { RolePermission, RolePermissionsService } from '../../../services/role-permissions.service';
import { ScreenName, LoadScheduleControlFlags } from '../../../interfaces/securityPermissions';

@Component({
  selector: 'app-addedit-site',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    MatButtonModule,
    MatCardModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSelectModule,
    MatTableModule,
    MatMenuModule,
    MatDialogModule,
    MatIcon,
    DragDropModule,
    MatSlideToggleModule
  ],
  templateUrl: './addedit-site.component.html',
  styleUrls: ['./addedit-site.component.scss'],
})
export class AddeditSiteComponent implements OnInit {

  @Input() siteData!: any;
  @Output() formEmitter = new EventEmitter<any>();

  siteTypes: IdName[] = [];
  displayValue=signal<string>('');

  siteForm!: FormGroup;
  isEditMode = false;
  markets: Regions[] = [];
  filteredMarkets: Regions[] = [];
  states: States[] = [];
  filteredStates: States[] = [];
  cities: Cities[] = [];
  filteredCities: Cities[] = [];
  disposalMethods: GetDisposalMethodsResponse[] = [];
  filteredDisposalMethods: GetDisposalMethodsResponse[] = [];

  data: any = {
    id: '',
    siteName: '',
    siteType: '',
    contactName: '',
    contactNumber: '',
    contactEmail: '',
    address1: '',
    address2: '',
    city: '',
    state: '',
    zipCode: '',
    regions: '',
    disposalMethods: '',
    disposalMethodids: '',
    oracleAccountNumber: '',
    oracleSiteNumber: '',
    normalCHGPEfficiency: null,
    conversionBTU: null,
    ch4LowHeatingvalue: null,
    manureGoal: null,
    chpCapacity: null,
    ssoGoal: null,
    volume: null,
    isRevenue: false,
    isActive: false
  };
  controlPermissions: LoadScheduleControlFlags = new LoadScheduleControlFlags();
  canSave: boolean = false;
  dataSource = new MatTableDataSource<any>();
  get isVRSelected(): boolean {
    const selectedId = this.siteForm.get('siteType')?.value;
    const selectedType = this.siteTypes.find(t => t.id === selectedId);
    return selectedType?.name === 'VR';
  }

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<AddeditSiteComponent>,
    @Inject(MAT_DIALOG_DATA) public injectedData: any,
    private _dialog: MatDialog,
    private lookUp: LookUpService,
    private rolesService: RoleService,
    private siteService: SiteService,
    private permissions: RolePermissionsService,
    private notificationService: NotificationService
  ) {
    this.canSave = injectedData.canSave;
    this.getPermissions();
    this.buildForm();
  }

  ngOnInit(): void {
    this.data = this.injectedData?.formData || this.data;
    this.isEditMode = !this.injectedData?.isAddForm;
    console.log('Form Data:', this.data);
    this.getMarketsData();
    this.getStatesData();
    if (this.data.id) {
      this.getSiteDetails(this.data.id);
    }
  }

  getPermissions(){        
    let roles = this.rolesService.getRolesAsString();
    console.log("roles", roles);
    this.permissions.getRolePermissionsNew(roles, ScreenName.SitePopup, 0).subscribe({
      next: (perms: LoadScheduleControlFlags) => {
        this.controlPermissions = perms;
        console.log("Site popup permissions ", perms);
      }
    })
  }

  getSiteDetails(id: string): void {
    this.siteService.getSiteById(id).subscribe({
      next: (response) => {
        this.data = response;
        console.log('Site Details:', this.data);
        if (this.data.disposalMethods) {
          this.data.disposalMethodids = Number(this.data.disposalMethods);
        }
  
        // Use patchValue to update the existing form
        this.siteForm.patchValue({
          ...this.data,
          disposalMethodids: this.data.disposalMethodids
        });

        this.getStatesData();
      }
    });
  }

  buildForm(): void {
    console.log("sie popup permissions", this.controlPermissions);
    const initialDisposalValue = this.data.disposalMethods ? Number(this.data.disposalMethods) : null;
    this.siteForm = this.fb.group({
      siteName: [{value: this.data.siteName, disabled: this.isEditMode == true ? this.controlPermissions.sitename: false }, Validators.required],
      siteType: [this.data.siteType, Validators.required],
      contactName: [this.data.contactName],
      contactNumber: [
        this.data.contactNumber,
        Validators.pattern(/^(\+1[- ]?)?(\([0-9]{3}\)|[0-9]{3})[- ]?[0-9]{3}[- ]?[0-9]{4}$/),
      ],
      contactEmail: [this.data.contactEmail, Validators.email],
      address1: [this.data.address1, Validators.required],
      address2: [this.data.address2],
      city: [this.data.city, Validators.required],
      state: [this.data.state, Validators.required],
      zipCode: [this.data.zipCode, [Validators.required, Validators.maxLength(10)]],
      regions: [this.data.regions, Validators.required],
      disposalMethodids: [initialDisposalValue],
      oracleAccountNumber: [this.data.oracleAccountNumber],
      oracleSiteNumber: [this.data.oracleSiteNumber],
      normalCHGPEfficiency: [this.data.normal_CHGP_Efficiency],
      conversionBTU: [this.data.conversion_BTU],
      ch4LowHeatingvalue: [this.data.cH4_Low_Heating_value],
      chpCapacity: [this.data.chP_Capacity],
      ssoGoal: [this.data.ssO_Goal],
      volume: [this.data.volume],
      manureGoal: [this.data.manure_Goal],
      isRevenue: [this.data.isRevenue ?? false],
      isActive: [this.data.isActive]
    });
  }

  onSubmit(): void {
    this.siteForm.markAllAsTouched();
    if (!this.siteForm.valid) return;

    const formData = { ...this.siteForm.value };
    formData['ID'] = this.data.id || 0;
    var dmids = formData['disposalMethodids'];

    formData['disposalMethodids'] = (dmids === null || dmids === undefined) ? null : String(dmids);
    console.log("site data too save", formData);
    this.siteService.createSite(formData).subscribe({
      next: () => {
        this.notificationService.show(
          this.isEditMode ? 'Site updated successfully' : 'Site created successfully',
          'success'
        );

        this.formEmitter.emit({ submit: true });
        this.dialogRef.close(true);
      }
    });
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }

  getMarketsData(): void {
    this.lookUp.getMarketsList('').subscribe({
      next: (response) => {
        this.markets = response;
        this.filteredMarkets = response;
      }
    });

    this.lookUp.getSiteTypes().subscribe({
      next: (response) => {
        this.siteTypes = response;
      }
    });
    this.lookUp.getAllDisposalMethods().subscribe({
      next: async (response) => {
        this.disposalMethods = response;
        this.filteredDisposalMethods = response;
        this.buildForm();
      }
    })
  }

  formatPhoneNumber(event: Event): void {
    const input = event.target as HTMLInputElement;
    let value = input.value.replace(/\D/g, '');
    let formattedValue = '';
    if (value.length > 0) {
      formattedValue = '(' + value.substring(0, 3);
    }
    if (value.length >= 4) {
      formattedValue += ') ' + value.substring(3, 6);
    }
    if (value.length >= 7) {
      formattedValue += '-' + value.substring(6, 10);
    }
    input.value = formattedValue;
    this.siteForm.get('contactNumber')?.setValue(formattedValue);
  }

  filterState(event: Event): void {
    const searchTerm = (event.target as HTMLInputElement).value.toLowerCase();
    if (!searchTerm) {
      this.filteredStates = [...this.states];
    } else {
      this.filteredStates = this.states.filter(
        state => state.state.toLowerCase().includes(searchTerm)
      );
    }
  }

  filterCity(event: Event): void {
    const searchTerm = (event.target as HTMLInputElement).value.toLowerCase();
    if (!searchTerm) {
      this.filteredCities = [...this.cities];
    } else {
      this.filteredCities = this.cities.filter(
        city => city.city.toLowerCase().includes(searchTerm)
      );
    }
  }

  filterMarket(event: Event): void {
    const searchTerm = (event.target as HTMLInputElement).value.toLowerCase();
    if (!searchTerm) {
      this.filteredMarkets = [...this.markets];
    } else {
      this.filteredMarkets = this.markets.filter(
        market => market.regionName.toLowerCase().includes(searchTerm)
      );
    }
  }

  filterDisposalMethod(event: Event): void {
    const searchTerm = (event.target as HTMLInputElement).value.toLowerCase();
    if (!searchTerm) {
      this.filteredDisposalMethods = [...this.disposalMethods];
    } else {
      this.filteredDisposalMethods = this.disposalMethods.filter(
        dm => dm.disposalMethod == null ? '' : dm.disposalMethod.toLowerCase().includes(searchTerm)
      );
    }
  }

  getStatesData(): void {
    this.lookUp.getStatesList().subscribe({
      next: (response) => {
        this.states = response;
        this.filteredStates = response;
        const stateObj = this.states.find((s) => s.state === this.data.state);
        if (stateObj) {
          // Update the form with the ID so mat-select matches [value]="state.id"
          this.siteForm.patchValue({ state: stateObj.state }, { emitEvent: false });
          // Load cities for this state ID
          this.onStateChanged(stateObj.state, true);
        } else if (this.data.state) {
            // If data.state is already an ID
            this.siteForm.patchValue({ state: this.data.state }, { emitEvent: false });
            this.onStateChanged(this.data.state, true);
        }
      }
    });
  }

  onStateChanged(state: string, isOnLoad?: boolean): void {
    let setStateId: number | null = null;
    if (state) {
      const selectedState = this.states.find((s) => s.state === state);
      setStateId = selectedState ? selectedState.id : null;
    }else {
      setStateId = null;
      this.cities = [];
      this.filteredCities = [];
      this.siteForm.patchValue({ city: '' });
      this.siteForm.get('city')?.setValue(null);
      this.siteForm.patchValue({ state: '' });
      this.siteForm.get('state')?.setValue(null);
      return;
    }
    this.siteService.getCitiesByState(setStateId).subscribe({
      next: (cities) => {
        this.cities = cities;
        this.filteredCities = cities;
        if (isOnLoad && this.data.city) {
          const foundCity = this.cities.find(
            (c) => c.city.toLowerCase() === this.data.city.trim().toLowerCase()
          );

          if (foundCity) {
            this.siteForm.patchValue({
              city: foundCity.city
            });
          }
        } else if (!isOnLoad) {
          this.siteForm.get('city')?.setValue(null);
        }
      },
    });
  }

  openContextmenu(data: any, action: string) {
    if (action === 'DELETE') {
      const dialogRef = this._dialog.open(AppDialogComponent, {
        width: '500px',
        height: '200px',
        data: {
          title: 'Delete',
          message: 'Are you sure you want to delete this record?',
          actions: ['OK', 'CANCEL'],
        },
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (result?.confirm) {
          console.log('Deleting record:', data);
        }
      });
    }
  }

  refreshGrid(): void {
    this.dataSource.data = [...this.dataSource.data];
  }

  roundOff(event: Event, maxValue: number, maxDecimals: number, type: number, controlName: string): void {
    const input = event.target as HTMLInputElement;
    let val = input.value;

    val = numericInputLimit(event, maxValue, maxDecimals);
    
    this.displayValue.set(val);
    
    input.value = val;
    const isValueEmpty = val === '' || val === '.';
    if (isValueEmpty) {
      this.siteForm.get(controlName)?.setValue(null, { emitEvent: false });
    } else if (val.endsWith('.')) {
      this.siteForm.get(controlName)?.setErrors({ 'incompleteDecimal': true });
    } else {      
      const parsedValue = parseFloat(val);
      this.siteForm.get(controlName)?.setValue(parsedValue, { emitEvent: false });
    }
  }
}
